import type { ComponentProps } from "react";

import { DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { elenailsTheme } from "@/lib/theme";

type Props = ComponentProps<typeof DropdownMenuContent>;

/** Shared menu surface used by account, theme and mobile menus. */
export function LiquidGlassMenuContent({ className, style, ...props }: Props) {
  return (
    <DropdownMenuContent
      {...props}
      className={cn("liquid-glass-menu", className)}
      style={{ ...elenailsTheme.styles.glassVars, ...style }}
    />
  );
}
